export default __webpack_public_path__ + "static/media/36I-120775_-43975_0.50c9631b.jpg";